import type { ChangeEventHandler } from "react";

import styled from "styled-components";

import { AutosizeInput } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { TITLE_MAX_LENGTH } from "app/pages/keyword-analysis/KeywordGroupEditorHelpers";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { useKeywordGroupNameContext } from "../KeywordGroupNameContext";

const Error = styled.div<{ isValid: boolean }>`
    opacity: ${({ isValid }) => (isValid ? 0 : 1)};
    font-size: 12px;
    transition: opacity 0.4s;
    height: 16px;
    color: red;
    margin-top: -8px;
    padding-left: 4px;
`;

export const GroupName = () => {
    const { keywordGroupName, keywordGroupNameValidationStatus, changeKeywordGroupName } = useKeywordGroupNameContext();
    const onNameChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        changeKeywordGroupName(e.target.value);
    };
    return (
        <FlexColumn>
            <AutosizeInput
                error={!keywordGroupNameValidationStatus.isValid}
                placeholder={translate("auto.keyword.list.generator.header.group.name.placeholder")}
                onChange={onNameChange}
                value={keywordGroupName}
                maxLength={TITLE_MAX_LENGTH}
            />
            <Error isValid={keywordGroupNameValidationStatus.isValid}>
                {"errorMessage" in keywordGroupNameValidationStatus
                    ? keywordGroupNameValidationStatus.errorMessage
                    : null}
            </Error>
        </FlexColumn>
    );
};
